<ng-template #confirmModal let-modal>
    <div class="modal-body pt-5 pb-4 tnx-img">
        <div class="content-modal"></div>
    </div>
    <div *ngIf="order" class="modal-body">
        <div class="content-modal">
            <h5 [innerHTML]="'order-confirmation-title' | translate"></h5>
            <p [innerHTML]="'order-confirmation-text' | translate: {$1: order?.NE__Cart_Description__c, $2: order?.NE__Service_Point__r?.Brand__c, $3: order?.NE__Service_Point__r?.Model__c}"></p>
            <button class="btn btn-primary w-100 mt-5" (click)="submitConfirmation()">{{ isInsuranceAvailable ? ( 'order-confirmation-cta-insurance' | translate) : ('order-confirmation-cta'| translate) }}</button>
        </div>
    </div>
</ng-template>